import { Component } from "react";
import { isAndroid, chromeIntent, reportClientError } from "@/lib/browser";

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    reportClientError(error, { component: String(info?.componentStack || "").slice(0, 1500) });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-5" data-testid="app-error-screen">
        <div className="card max-w-md w-full space-y-3">
          <h2 className="text-xl font-black">Aplikasi mengalami kendala</h2>
          <p className="text-sm text-[var(--muted)]">Tekan Muat Ulang. Jika masih gagal, buka aplikasi di Google Chrome dan perbarui Chrome serta Android System WebView di Play Store.</p>
          <p className="text-xs text-[var(--error)] break-words" data-testid="app-error-message">{String(this.state.error?.message || this.state.error)}</p>
          <button className="btn btn-primary w-full" onClick={() => window.location.reload()} data-testid="app-error-reload">Muat Ulang</button>
          {isAndroid && <a className="btn btn-soft w-full" href={chromeIntent()} data-testid="app-error-open-chrome">Buka di Chrome</a>}
        </div>
      </div>
    );
  }
}
